import { ModelType } from '@/enums/model-type.enum';

/** GPT Image 2 uses the legacy generation/edit types; 2.5 has its own type. */
export const GPT_IMAGE_MODEL_TYPES: ReadonlySet<ModelType> = new Set([
  ModelType.GptImage1,
  ModelType.GptImage1Edit,
  ModelType.GptImage25,
]);
